const labTestQuestions = [

    {label:"Date of test",
    controlType:"date",
    options:[ ],
    },

    {label:"Lab where test performed:",
    controlType:"text",
    options:[ ],
    },

    
    {label:"Results available electronically in GP record?",
    controlType:"radio button",
    options:["Yes", "No"],
    },


    {label:"Result(s) (if not available electronically):",
    controlType:"text",
    options:[ ],
    },

    {label:"Comments",
    controlType:"text area",
    options:[ ],
    }

]

export default labTestQuestions